/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionPresetCounts
 */
export interface PalSubmissionPresetCounts {
    /**
     * Count of submissions in the Not Submitted preset bucket.
     */
    notSubmitted: number;
    /**
     * Count of submissions in the In Review preset bucket.
     */
    inReview: number;
    /**
     * Count of submissions in the Following preset bucket (including the denied-by-admission split).
     */
    following: number;
}

/**
 * Check if a given object implements the PalSubmissionPresetCounts interface.
 */
export function instanceOfPalSubmissionPresetCounts(value: object): value is PalSubmissionPresetCounts {
    if (!('notSubmitted' in value) || value['notSubmitted'] === undefined) return false;
    if (!('inReview' in value) || value['inReview'] === undefined) return false;
    if (!('following' in value) || value['following'] === undefined) return false;
    return true;
}

export function PalSubmissionPresetCountsFromJSON(json: any): PalSubmissionPresetCounts {
    return PalSubmissionPresetCountsFromJSONTyped(json, false);
}

export function PalSubmissionPresetCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionPresetCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'notSubmitted': json['notSubmitted'],
        'inReview': json['inReview'],
        'following': json['following'],
    };
}

export function PalSubmissionPresetCountsToJSON(json: any): PalSubmissionPresetCounts {
    return PalSubmissionPresetCountsToJSONTyped(json, false);
}

export function PalSubmissionPresetCountsToJSONTyped(value?: PalSubmissionPresetCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notSubmitted': value['notSubmitted'],
        'inReview': value['inReview'],
        'following': value['following'],
    };
}

